import type { FaireProductEntity } from "../../entity_types/product";

export const p_kwdeqkfz38: FaireProductEntity = {
  token: "p_kwdeqkfz38",
  type: "product",
  name: "Fanta Tropical Exotic 330ml (European)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/ffd8c0def2e0c021b33783d6665c3aa2c87255ebaaf03f17fb20b8abb3fbad16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a25a819ccbf6a6a809b8f7534ad4bcc31bb631af5b34eebcbd7209a1529bff4.png",
  ],
  priceDollars: 2.66,
  description:
    "Fanta Tropical Exotic 330ML is a refreshingly vibrant and tropical beverage that brings a taste of paradise in every sip. Bursting with exotic fruit flavors, this fizzy delight combines the sweetness of tropical fruits to create a unique and enjoyable experience for your taste buds.",
  tags: [],
  msrpDollars: 4.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:57.634Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
